<template>
	<div class="container-md mh-100">
		<LayoutHeaderSection>
			<template #title>
				<LayoutTextSection :text="company?.name" :breadcrumb="true" />
			</template>
		</LayoutHeaderSection>
		<main class="py-5 vstack gap-3">
			<CompanyAdminHomeStatList v-if="company.pivot.roles.includes('admin')" />
			<CompanyLeaderCustomerCommonBirthday v-else-if="company.pivot.roles.includes('leader')" />
			<CompanyCommonShortcutList />
		</main>
	</div>
</template>

<script>
	import { computed } from 'vue';
	import store from '@/store';

	export default {
		setup() {
			const company = computed(() => store.getters['company/info']);

			return { company };
		}
	}
</script>